import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
const routes = [{
  path: '/',
  // redirect: '/demo',
  name: 'index',
  component: () => import('../views/demo.vue')
}, {
  path: '/inside',
  name: 'Inside',
  component: () => import('../views/inside/index.vue')
}, {
  path: '/outside',
  name: 'Outside',
  component: () => import('../views/outside/index.vue')
}, {
  path: '/demo',
  name: 'Demo',
  component: () => import('../views/demo.vue')
}];
const router = new VueRouter({
  mode: 'history',
  // @ts-ignore
  scrollBehavior: () => ({
    y: 0
  }),
  routes
});
export default router;